(() => {
  if (document.documentElement.dataset.vivantBundleAjaxReady === 'true') return;
  document.documentElement.dataset.vivantBundleAjaxReady = 'true';

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('cart-drawer .drawer__close-btn');
    if (!closeButton) return;
    const drawer = closeButton.closest('cart-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.vivant-bundle-ajax-form');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const originalText = button.textContent.trim();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';

    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections }
      }));
      const formData = new FormData(form);
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const addedItem = await response.json();
      if (!response.ok) throw new Error(addedItem.description || 'Unable to add the bundle.');

      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      const cart = await cartResponse.json();
      cart.sections = addedItem.sections;

      if (window.FoxTheme?.pubsub?.publish && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      }
      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: { product: addedItem }
      }));

      const ensureDrawerOpen = () => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || drawer.open) return;
        const cartToggle = document.querySelector('[aria-controls="CartDrawer"]');
        if (cartToggle) cartToggle.click();
        else if (typeof drawer.show === 'function') drawer.show(button);
      };
      window.setTimeout(ensureDrawerOpen, 450);
      window.setTimeout(ensureDrawerOpen, 1600);

      button.textContent = 'Added ✓';
      window.setTimeout(() => { button.textContent = originalText; }, 1800);
    } catch (error) {
      button.textContent = error.message || 'Please try again';
      window.setTimeout(() => { button.textContent = originalText; }, 2400);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
